"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get getCacheDirectory () {
        return getCacheDirectory;
    },
    get getCacheDirectoryRoot () {
        return getCacheDirectoryRoot;
    },
    get getLogsCacheDirectory () {
        return getLogsCacheDirectory;
    }
});
const _path = /*#__PURE__*/ _interop_require_default(require("path"));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function getCacheDirectoryRoot(root) {
    return _path.default.join(root, "node_modules", ".cache", "lage");
}
function getCacheDirectory(root, hash) {
    return _path.default.join(getCacheDirectoryRoot(root), "cache", hash.substring(0, 4));
}
function getLogsCacheDirectory(root, hash) {
    return _path.default.join(getCacheDirectoryRoot(root), "logs", hash.substring(0, 4));
}
